import axios from '@/utils/request'
const urlPrefix = 'map'

// 获取区域列表
export function getArealList (params) {
  return axios({
    url: urlPrefix + '/area/list/all',
    method: 'get',
    params: params
  })
}

// 新建地图
export function addMap (params) {
  return axios({
    url: urlPrefix + '/map',
    method: 'POST',
    data: params
  })
}

// 获取地图详情
export function getMapDetails (params) {
  return axios({
    url: urlPrefix + '/map',
    method: 'get',
    params: params
  })
}

// 获取地图列表
export function getMapPages (params) {
  return axios({
    url: urlPrefix + '/map/page',
    method: 'get',
    params: params
  })
}

// 删除地图
export function deleteMap (params) {
  return axios({
    url: urlPrefix + '/map',
    method: 'DELETE',
    data: params
  })
}

export function addEditMap (params) {
  return axios({
    url: urlPrefix + '/map',
    method: 'PUT',
    data: params
  })
}

// 设置模板地图
export function addTemplateMap (params) {
  return axios({
    url: urlPrefix + '/map/template',
    method: 'POST',
    data: params
  })
}

// 移除模板地图
export function removeTemplateMap (params) {
  return axios({
    url: urlPrefix + '/map/template/cancel',
    method: 'POST',
    data: params
  })
}

// 获取模板地图列表
export function getTemplateMap (params) {
  return axios({
    url: urlPrefix + '/map/page/template',
    method: 'get',
    params: params
  })
}

// 获取分享地图列表
export function getShareMap (params) {
  return axios({
    url: urlPrefix + '/map/share/map/page',
    method: 'get',
    params: params
  })
}

// 文件夹图层排序
export function sortLayer (params) {
  return axios({
    url: urlPrefix + '/map/sort',
    method: 'PUT',
    data: params
  })
}

// 分享地图
export function shareMap (params) {
  return axios({
    url: urlPrefix + '/map/share/enable',
    method: 'PUT',
    data: params
  })
}

// 创建分享
export function createShare (data) {
  const { layerIds } = data.data
  data.data.layerIds = layerIds.filter(p => typeof p === 'string').map(p => Number(p.replace('layer-', '')))
  data.data.folderIds = layerIds.filter(p => typeof p === 'number')
  return axios({
    url: urlPrefix + '/map/share/create',
    method: 'post',
    data: data
  })
}

// 删除分享
export function deleteShare (params) {
  return axios({
    url: urlPrefix + '/map/share',
    method: 'DELETE',
    params: params
  })
}

// 修改分享
export function updateShare (data) {
  return axios({
    url: urlPrefix + '/map/share/update',
    method: 'PUT',
    data: data
  })
}

// 获取分享分页
export function getSharePage (params) {
  return axios({
    url: urlPrefix + '/map/share/page',
    method: 'get',
    params: params
  })
}

// 分享模板案例
export function shareTemplate (params) {
  return axios({
    url: urlPrefix + '/map/template/share',
    method: 'post',
    data: params
  })
}

// 获取分享配置
export function getShareMapSetting (shareId) {
  return axios({
    url: urlPrefix + '/map/share/noncestr',
    method: 'get',
    params: {
      noncestr: shareId
    }
  }).then(req => {
    const { data } = req.data
    // Array.prototype.push.apply(data.folderIds, data.layerIds.map(p => `layer-${p}`))
    data.layerIds = data.layerIds.map(p => `layer-${p}`).concat(data.folderIds)
    // params.data.layerIds = layerIds.filter(p => typeof p === 'string').map(p => Number(p.replace('layer-', '')))
    console.log(data.layerIds)
    return req
  })
}

// 获取附带图层列表的文件夹列表(树状结果)
export function getLayerTree (params, shareId) {
  return axios({
    url: urlPrefix + '/layer/folder/list/layers',
    method: 'get',
    headers: {
      config: true,
      share: shareId
    },
    params: params
  }).then(req => {
    const { data } = req
    const fn = function (p2) {
      if (!p2.children) {
        p2.children = []
      }
      p2.layers && p2.layers.forEach(p => (p.id = `layer-${p.id}`))
      Array.prototype.push.apply(p2.children, p2.layers)
      p2.children.forEach(p => fn(p))
    }
    data.layers && data.layers.forEach(p => (p.id = `layer-${p.id}`))
    Array.prototype.push.apply(data.children, data.layers)
    data.children.concat(data.layers);
    // _.merge(data.children, data.layers);

    (data.children || []).forEach(p => fn(p))
    return req
  })
}

// 获取视点列表信息
export function getViewPointList (params, shareId) {
  return axios({
    url: urlPrefix + '/map/viewpoint/list',
    method: 'get',
    headers: {
      config: true,
      share: shareId
    },
    params: params
  })
}

// 获取动画列表信息
export function getViewAnimationList (params, shareId) {
  return axios({
    url: urlPrefix + '/map/viewpoint/animation/list',
    method: 'get',
    headers: {
      config: true,
      share: shareId
    },
    params: params
  })
}

// 获取路径规划数据
export function getRoutes (mapId, shareId) {
  return axios({
    url: urlPrefix + '/path/page',
    method: 'get',
    headers: {
      config: true,
      share: shareId
    },
    params: { mapId, pageSize: 9999 }
  })
}

// 应用生效
export function applicationEffect (params, shareId) {
  console.log(params)
  const { layerIds } = params.data
  params.data.layerIds = layerIds.filter(p => typeof p === 'string').map(p => Number(p.replace('layer-', '')))
  params.data.folderIds = layerIds.filter(p => typeof p === 'number')
  return axios({
    url: urlPrefix + '/map/share',
    method: 'PUT',
    data: {
      ...params,
      noncestr: shareId
    }
  })
}
/**
 * 复制地图
 * @param {Number} mapId 地图id
 * @returns
 */
export async function copyMap (mapId) {
  return axios.post('/map/map/copy', {
    id: mapId
  })
}
